import React from "react";
import logger from "logger";
import AngCheckbox from "Common/Angular/AngCheckbox";

export default function(props) {
  const { label, AccountDetailData, setValue, param, taskConfig } = props;
  const selectedcities = taskConfig[param];

  return (
    <div style={{ padding: "7px" }}>
      <div>{label}</div>
      {AccountDetailData.heroes.map((city) => {
        return (
          <div>
            <AngCheckbox
              value={selectedcities[city.cityno]}
              onChange={() => {
                const newValue = {
                  ...selectedcities,
                  [city.cityno]: !selectedcities[city.cityno],
                };
                setValue({ target: { value: newValue } }, param);
              }}
            >
              {city.cityname}
            </AngCheckbox>
          </div>
        );
      })}
    </div>
  );
}
